import styled from 'styled-components'

export const Wrapper = styled.div`
  text-align: center;
  margin-bottom: 44px;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
